import { Card, CardContent, CardMedia, styled, Typography } from '@mui/material'

export type BusinessModelCardProps = {
  title: string
  description: string
  imageSrc: string
  isSelected: boolean
  disabled?: boolean
  onClick: () => void
}

export const BusinessModelCard: React.FC<BusinessModelCardProps> = ({
  title,
  description,
  imageSrc,
  isSelected,
  disabled = false,
  onClick,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick()
    }
  }

  return (
    <StyledCard
      isSelected={isSelected}
      disabled={disabled}
      onClick={handleClick}
    >
      <CardMedia
        component="img"
        height="140"
        image={imageSrc}
        alt={title}
        sx={{ padding: 2, objectFit: 'contain' }}
      />
      <CardContent>
        <Typography variant="h6" align="center">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          {description}
        </Typography>
      </CardContent>
    </StyledCard>
  )
}

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'isSelected' && prop !== 'disabled',
}) <{ isSelected: boolean; disabled: boolean }>`
  width: 100%;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease-in-out;
  border: 2px solid;
  border-color: ${props => {
    if (props.disabled) {
      return props.theme.palette.action.disabled
    }

    return props.isSelected ? props.theme.palette.primary.main : props.theme.palette.divider
  }};
  box-shadow: 0 !important;
  opacity: ${props => props.disabled ? 0.6 : 1};
  
  &:hover {
    ${props => !props.disabled && `
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12) !important;
    `}
  }

  ${props => props.disabled && `
    .MuiTypography-root {
      color: ${props.theme.palette.text.disabled};
    }
    
    .MuiCardMedia-root {
      filter: grayscale(100%);
      opacity: 0.5;
    }
  `}
`